import React from 'react'
import ClayTable from "@clayui/table";
import { CGE } from '../../../../common/components/CGE';
import {changeCurrancyFormat} from "../../../../common/utils/utilsFunc"
function AssociatedClientsTable({props}) {

  return (
      <ClayTable class="table table-striped table-autofit show-quick-actions-on-hover table-list table-nowrap tbody-valign-middle thead-valign-middle table-valign-middle" id="table-to-xls">
          <ClayTable.Head>
            <ClayTable.Row>
              {props.newArrTitle?.map((title) => {
                return (
                  <ClayTable.Cell headingCell className="clientCell font-weight-bold">
                    {title}
                  </ClayTable.Cell>
                );
              })}
            </ClayTable.Row>
          </ClayTable.Head>
          <ClayTable.Body>
          {props.currentArray ? (
                props.currentArray?.map((obj) => {
                  return (
                    <ClayTable.Row className="tableRow" >
                      {Object.keys(obj).map((index) => {
                        return (
                          <ClayTable.Cell className=" txt-with-link clientCell-td table-cell-minw-150  text-truncate" title={obj[index].length > 23 ? obj[index] : ''}>
                            {index === 'ESTADO_PAGO' && obj[index] === 'IMPAGO' ? <a href={`detalle-de-cuenta-priv?ctacto=${obj['CTA_CTO']}`} className='text-decoration-none '>¡PAGAR AQUÍ!</a> :
                            index === "opciones" ? 
                              <div className="d-flex align-items-center">
                                  <a
                                      title="Editar"
                                      onClick={() => props.handleClickButtonModification(obj)}
                                  >
                                      <div className="mr-3">
                                          <CGE.Icon style={{ fontSize: "40px" }} name="document" />
                                      </div>
                                  </a>
                                  <a
                                  title="Eliminar"
                                      onClick={() => props.handleClickButtonAnulation(obj)}
                                  >
                                      <CGE.Icon style={{ fontSize: "40px" }} name="trash" />
                                  </a>
                              </div> :
                              index === "TOTAL_PAGAR" ? 
                              changeCurrancyFormat(Number(obj[index]),true) :
                                obj[index]
                              }
                          </ClayTable.Cell>)
                      })}
                    </ClayTable.Row>
                  );
                })
              ) : (
                <ClayTable.Row>
                  <ClayTable.Cell colspan={props.newArrTitle?.length} className="text-no-results  font-weight-bold"></ClayTable.Cell>
                </ClayTable.Row>
              )}
          </ClayTable.Body>
        </ClayTable>
  )
}

export default AssociatedClientsTable